<template>
  <a class="contact-number"
     :class="`contact-number--${color}`"
     :href="`http://api.whatsapp.com/send?1=pt_BR&phone=${unmaskedPhone}`"
     target="_blank"
  >
    <span>
      {{ phone }}
    </span>
    <font-awesome-icon :icon="['fab', 'whatsapp']"
                       class="contact-number__icon"
                       :class="`contact-number__icon--${color}`"
    />
  </a>
</template>
<script>
import { getPhoneNumber } from '@/utils'

export default {
  name: 'ContactNumber',
  props: {
    color: String
  },
  computed: {
    phone () {
      return getPhoneNumber()
    },
    unmaskedPhone () {
      return getPhoneNumber(true)
    }
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.contact-number
  @apply relative text-center
  &--pink
    @apply text-pink
  &__icon
    @apply absolute -translate-y-50 text-xl text-green
    right: -30px
    top: calc(50% - 2px)
    &--pink
      @apply text-pink
</style>
